module.exports = __webpack_public_path__ + "img/CA.3d7d8961.svg";